import { render, staticRenderFns } from "./TenantAndLeadsList.vue?vue&type=template&id=470535a2&scoped=true&"
import script from "./TenantAndLeadsList.vue?vue&type=script&lang=js&"
export * from "./TenantAndLeadsList.vue?vue&type=script&lang=js&"
import style0 from "./TenantAndLeadsList.vue?vue&type=style&index=0&id=470535a2&prod&lang=scss&scoped=true&"
import style1 from "./TenantAndLeadsList.vue?vue&type=style&index=1&id=470535a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470535a2",
  null
  
)

export default component.exports